'use client';
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';

import Icon from 'molecules/Icon';
import styles from 'molecules/Socials/share.module.scss';

import type { FC } from 'react';

interface SocialsProps {
  slug: string;
}

const domain = process.env.NEXT_PUBLIC_DOMAIN;

const Socials: FC<SocialsProps> = ({ slug }) => {
  const url = `${domain}/${slug}`;

  return (
    <div className={styles.shareContainer}>
      <div
        role="button"
        tabIndex={0}
        onClick={() => window.print()}
        onKeyUp={e => {
          if (e.code === 'Enter' || e.code === 'Space') {
            window.print();
          }
        }}
      >
        <Icon icon="print" size={20} />
      </div>
      <EmailShareButton url={url}>
        <Icon icon="email" size={20} />
      </EmailShareButton>
      <FacebookShareButton url={url}>
        <Icon icon="facebook" size={20} />
      </FacebookShareButton>
      <TwitterShareButton url={url}>
        <Icon icon="twitter" size={20} />
      </TwitterShareButton>
      <LinkedinShareButton url={url}>
        <Icon icon="linkedin" size={20} />
      </LinkedinShareButton>
    </div>
  );
};

export default Socials;
